// extracted by mini-css-extract-plugin
export default {"add_icon":"ImageFieldDropzoneUpload_add_icon__1JGP5"};